import { sanitizer } from "./helpers";

export default function extractText(str) {
  const purifiedText = sanitizer.sanitizeAllowHtml(str);
  const span = document.createElement("span");
  span.innerHTML = purifiedText;
  return span.innerText;
}
